module.exports = __webpack_public_path__ + "img/ng.bf513833.svg";